module.exports = __webpack_public_path__ + "files/04823c223be85f2cfec8c3b76297f4da.png";